import { type ReactNode } from "react";

import { useTemplateEntity } from "../templateEntity";
import { DeprecatedTemplateNotice } from "./DeprecatedTemplateNotice";

const DEPRECATED_LIFECYCLE = "deprecated";

/** Props for {@link DeprecationGuard}. */
type Props = { children: ReactNode };

/**
 * Guards the scaffolder template page by intercepting deprecated templates.
 *
 * Reads the template entity from the surrounding `TemplateEntityProvider`.
 * When the entity's lifecycle is `"deprecated"`, the normal page content is
 * replaced with a {@link DeprecatedTemplateNotice}. While the entity is
 * loading, or when there is no template entity, children are rendered
 * unchanged.
 *
 * @param props - {@link Props}
 */
export function DeprecationGuard({ children }: Props) {
    const { entity, loading } = useTemplateEntity();

    if (loading || entity?.spec.lifecycle !== DEPRECATED_LIFECYCLE) {
        return <>{children}</>;
    }

    return <DeprecatedTemplateNotice entity={entity} />;
}
